module.exports = __webpack_public_path__ + "media/images/ecalls/01_header_arrow_up-553df3703dffef92ce544c1e62310a91.png";